<template>
  <a-card @click="emit('toggle')" size="small" :class="{ isSelected }">
    <a-flex align="center" justify="space-between" gap="small">
      <slot
        v-if="!!$slots?.headerData"
        name="headerData"
        :item="item"
        style="flex-grow: 1"
      />
      <a-typography-text
        v-else-if="header"
        :content="header"
        ellipsis
        style="flex-grow: 1"
      />
      <div v-else style="flex-grow: 1"></div>

      <a-button type="text" class="button-expand" :class="{ expanded }">
        <template #icon>
          <TwoArrowsIcon />
        </template>
      </a-button>
    </a-flex>
  </a-card>

  <slot name="panelData" v-if="expanded" :item="item" />
</template>

<script setup lang="ts">
import TwoArrowsIcon from "@/svgIcons/TwoArrowsIcon.vue";

defineProps<{
  header?: string;
  item: any;
  expanded: boolean;
  isSelected: boolean;
}>();

const emit = defineEmits<{
  (e: "toggle"): void;
}>();
</script>

<style scoped lang="scss">
.ant-card {
  &.isSelected {
    border-color: var(--color-primary);
  }

  :deep(.ant-card-body) {
    padding: 5px 15px;
  }
}
.button-expand {
  --size: 15px;
  padding: 0;
  flex-shrink: 0;
  font-size: var(--size);
  line-height: 1;
  width: var(--size);
  height: var(--size);
  margin-left: auto;

  svg {
    width: 100%;
    height: 100%;
  }

  &.expanded {
    transform: rotate(180deg);
  }
}
//.ant-collapse-item {
//  .ant-collapse-arrow {
//    transition: all 0.3s ease-in-out;
//  }
//
//  &.ant-collapse-item-active .ant-collapse-arrow {
//    transform: rotate(-180deg);
//  }
//}
</style>
